"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSealedSecret = exports.encryptValues = exports.encryptValue = exports.encryptFromPublicKey = exports.getLabel = exports.pemPublicKeyToCryptoKey = exports.HybridDecrypt = exports.HybridEncrypt = void 0;
var node_forge_1 = require("node-forge");
// Utility functions come from here : https://developers.google.com/web/updates/2012/06/How-to-convert-ArrayBuffer-to-and-from-String
var utils_1 = require("./utils");
var crypto = typeof window !== 'undefined' && window.crypto ? window.crypto : require('crypto').webcrypto;
// Recommended nonce size for AES GCM is 96 bits
var AES_GCM_NONCE_SIZE = 12;
/**
 * Converts an ArrayBuffer to a string
 * @param buf
 */
function ab2str(buf) {
    return new TextDecoder().decode(buf);
}
function numberToLEBuffer(num) {
    var firstNumber = num / 256;
    var secondNumber = num % 256;
    return new Uint8Array([firstNumber, secondNumber]);
}
function numberFromLEBuffer(buffer) {
    var intArray = new Uint8Array(buffer.slice(0, 2));
    return intArray[0] * 256 + intArray[1];
}
/**
 * Encrypts a string using AES-GCM algorithm with a 0 nonce
 * @param key
 * @param str
 */
var aesGcmEncrypt = function (key, str) { return __awaiter(void 0, void 0, void 0, function () {
    var nonce;
    return __generator(this, function (_a) {
        nonce = new Uint8Array(AES_GCM_NONCE_SIZE);
        nonce.fill(0);
        return [2 /*return*/, crypto.subtle.encrypt({
                name: 'AES-GCM',
                iv: nonce,
            }, key, utils_1.str2ab(str))];
    });
}); };
/**
 * Decrypts an array buffer using AES-GCM algorithm with a 0 nonce
 * @param key
 * @param enc
 */
var aesGcmDecrypt = function (key, enc) { return __awaiter(void 0, void 0, void 0, function () {
    var nonce, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                nonce = new Uint8Array(AES_GCM_NONCE_SIZE);
                nonce.fill(0);
                return [4 /*yield*/, crypto.subtle.decrypt({
                        name: 'AES-GCM',
                        iv: nonce,
                    }, key, enc)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, ab2str(result)];
        }
    });
}); };
var sessionKeyLength = 256;
/**
 * Encrypts a string with AES-GCM/RSA-OAEP
 * @param pubKey - The RSA public key
 * @param text - The text to encrypt
 * @param label - The OAEP label
 * @constructor
 */
function HybridEncrypt(pubKey, text, label) {
    return __awaiter(this, void 0, void 0, function () {
        var sessionKey, rawSessionKey, rsaCipherText, rsaCipherLength, result, resultBuffer;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, crypto.subtle.generateKey({ name: 'AES-GCM', length: sessionKeyLength }, true, ['encrypt'])];
                case 1:
                    sessionKey = _a.sent();
                    return [4 /*yield*/, crypto.subtle.exportKey('raw', sessionKey)];
                case 2:
                    rawSessionKey = _a.sent();
                    return [4 /*yield*/, crypto.subtle.encrypt({
                            name: 'RSA-OAEP',
                            label: label,
                        }, pubKey, rawSessionKey)];
                case 3:
                    rsaCipherText = _a.sent();
                    rsaCipherLength = numberToLEBuffer(rsaCipherText.byteLength);
                    return [4 /*yield*/, aesGcmEncrypt(sessionKey, text)];
                case 4:
                    result = _a.sent();
                    resultBuffer = new Uint8Array(rsaCipherLength.byteLength + rsaCipherText.byteLength + result.byteLength);
                    resultBuffer.set(new Uint8Array(rsaCipherLength), 0);
                    resultBuffer.set(new Uint8Array(rsaCipherText), rsaCipherLength.byteLength);
                    resultBuffer.set(new Uint8Array(result), rsaCipherLength.byteLength + rsaCipherText.byteLength);
                    return [2 /*return*/, resultBuffer.buffer];
            }
        });
    });
}
exports.HybridEncrypt = HybridEncrypt;
/**
 * Decrypts a string with AES-GCM/RSA-OAEP
 * @param privKey - The RSA private key
 * @param cipherText - The encrypted text
 * @param label - The OAEP label
 * @constructor
 */
function HybridDecrypt(privKey, cipherText, label) {
    return __awaiter(this, void 0, void 0, function () {
        var rsaLength, rsaCipherText, aesCipherText, sessionKey, key;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rsaLength = numberFromLEBuffer(cipherText.slice(0, 2));
                    rsaCipherText = new Uint8Array(cipherText.slice(2, 2 + rsaLength));
                    aesCipherText = new Uint8Array(cipherText.slice(2 + rsaLength));
                    return [4 /*yield*/, crypto.subtle.decrypt({
                            name: 'RSA-OAEP',
                            label: label,
                        }, privKey, rsaCipherText)];
                case 1:
                    sessionKey = _a.sent();
                    return [4 /*yield*/, crypto.subtle.importKey('raw', sessionKey, { name: 'AES-GCM', length: sessionKeyLength }, false, [
                            'decrypt',
                        ])];
                case 2:
                    key = _a.sent();
                    return [2 /*return*/, aesGcmDecrypt(key, aesCipherText)];
            }
        });
    });
}
exports.HybridDecrypt = HybridDecrypt;
function uint8Str2Ab(str) {
    var buf = new ArrayBuffer(str.length);
    var bufView = new Uint8Array(buf);
    for (var i = 0, strLen = str.length; i < strLen; i += 1) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
}
var atob = typeof window !== 'undefined'
    ? window.atob
    : function (str) {
        return Buffer.from(str, 'base64').toString('binary');
    };
function pemPublicKeyToCryptoKey(pemContent) {
    return __awaiter(this, void 0, void 0, function () {
        var data, keyBuffer;
        return __generator(this, function (_a) {
            data = pemContent
                .replace(/-*BEGIN PUBLIC KEY-*/, '')
                .replace(/-*END PUBLIC KEY-*/, '')
                .replace(/\n/g, '');
            keyBuffer = uint8Str2Ab(atob(data));
            return [2 /*return*/, crypto.subtle.importKey('spki', keyBuffer, { name: 'RSA-OAEP', hash: 'SHA-256' }, true, ['encrypt'])];
        });
    });
}
exports.pemPublicKeyToCryptoKey = pemPublicKeyToCryptoKey;
// from https://github.com/bitnami-labs/sealed-secrets/blob/4d699355c7f7f3fb9dbd4247cef9f11e4f14f26b/pkg/apis/sealed-secrets/v1alpha1/sealedsecret_expansion.go#L77
exports.getLabel = function (_a) {
    var scope = _a.scope, namespace = _a.namespace, name = _a.name;
    if (scope === 'cluster') {
        return '';
    }
    if (scope === 'namespace') {
        return namespace;
    }
    return namespace + "/" + name;
};
/**
 * Return public `CryptoKey` from pemKey
 * @constructor
 */
var getPublicKey = function (pemKey) { return __awaiter(void 0, void 0, void 0, function () {
    var cert, publicKeyPem, publicKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cert = node_forge_1.pki.certificateFromPem(pemKey);
                publicKeyPem = node_forge_1.pki.publicKeyToPem(cert.publicKey);
                return [4 /*yield*/, pemPublicKeyToCryptoKey(publicKeyPem)];
            case 1:
                publicKey = _a.sent();
                return [2 /*return*/, publicKey];
        }
    });
}); };
exports.encryptFromPublicKey = function (args) { return __awaiter(void 0, void 0, void 0, function () { var _a, _b; return __generator(this, function (_c) {
    switch (_c.label) {
        case 0:
            _b = (_a = Buffer).from;
            return [4 /*yield*/, HybridEncrypt(args.publicKey, args.value, args.label)];
        case 1: return [2 /*return*/, _b.apply(_a, [_c.sent()]).toString('base64')];
    }
}); }); };
/**
 * Encrypt a single value
 * @constructor
 */
exports.encryptValue = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var publicKey, label, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getPublicKey(args.pemKey)];
            case 1:
                publicKey = _a.sent();
                label = Buffer.from(exports.getLabel({ scope: args.scope, namespace: args.namespace, name: args.name }));
                return [4 /*yield*/, exports.encryptFromPublicKey({ publicKey: publicKey, label: label, value: args.value })];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result];
        }
    });
}); };
/**
 * Encrypt a bunch of values
 * @constructor
 */
exports.encryptValues = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var publicKey, label, encryptedValues;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getPublicKey(args.pemKey)];
            case 1:
                publicKey = _a.sent();
                label = Buffer.from(exports.getLabel({ scope: args.scope, namespace: args.namespace, name: args.name }));
                return [4 /*yield*/, Promise.all(Object.keys(args.values).map(function (key) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = {
                                        key: key
                                    };
                                    return [4 /*yield*/, exports.encryptFromPublicKey({ publicKey: publicKey, label: label, value: args.values[key] })];
                                case 1: return [2 /*return*/, (_a.value = _b.sent(),
                                        _a)];
                            }
                        });
                    }); }))];
            case 2:
                encryptedValues = (_a.sent()).reduce(function (a, c) {
                    var _a;
                    return (__assign(__assign({}, a), (_a = {}, _a[c.key] = c.value, _a)));
                }, {});
                return [2 /*return*/, encryptedValues];
        }
    });
}); };
/**
 * Create a sealed-secret manifest and encrypt values
 * @constructor
 */
exports.getSealedSecret = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var encryptedData, annotations, manifest;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exports.encryptValues(args)];
            case 1:
                encryptedData = _a.sent();
                annotations = {};
                if (args.scope === 'cluster') {
                    annotations['sealedsecrets.bitnami.com/cluster-wide'] = 'true';
                }
                else if (args.scope === 'namespace') {
                    annotations['sealedsecrets.bitnami.com/namespace-wide'] = 'true';
                }
                manifest = {
                    apiVersion: 'bitnami.com/v1alpha1',
                    kind: 'SealedSecret',
                    metadata: {
                        annotations: annotations,
                        name: args.name,
                        namespace: args.namespace,
                    },
                    spec: {
                        encryptedData: encryptedData,
                        template: {
                            metadata: {
                                annotations: annotations,
                                name: args.name,
                            },
                            type: 'Opaque',
                        },
                    },
                };
                return [2 /*return*/, manifest];
        }
    });
}); };
//# sourceMappingURL=index.js.map